
export default function (iconCategories) {

    iconCategories.forEach((iconCategory, index) => {
        const trigger = iconCategory.querySelector(".icon-category-trigger");
        trigger.addEventListener("click", function (e) {
            const clickedCategoryDropdown = this.parentElement.querySelector(".icon-category-dropdown"); // dropdown in the same icon-category

            if (!clickedCategoryDropdown.querySelector(".subcategory")) return; // if has no dropdown, works as <a>

            e.preventDefault(); // removes link
            const clickedCategoryDropdownClone = clickedCategoryDropdown.cloneNode(true);
            clickedCategoryDropdownClone.setAttribute("data-dropdown-id", index);
            setDropdownRow(clickedCategoryDropdownClone, index)
            handleDropdowns(clickedCategoryDropdownClone, index, trigger);
        });
    });

    function setDropdownRow(dropdown, index) {
        const cs = getComputedStyle(document.documentElement);
        const columnsNum = +cs.getPropertyValue('--categorySectionColumns');
        const rowsNum = Math.ceil(iconCategories.length / columnsNum);

        const rowsTotalLengths = []; // 3 rows - [8, 16, 24]
        for (let i = 1; i <= rowsNum; i++) {
            rowsTotalLengths.push(columnsNum * i);
        }

        for (let i = 0; i < rowsTotalLengths.length; i++) {
            if (index < rowsTotalLengths[i]) {
                dropdown.style[`grid-row`] = i + 2; // +1 cause i=0, +1 cause visually below in css
                break;
            }
        }
    }
    function handleDropdowns(dropdownToShow, index, trigger) {
        const categoriesSection = document.querySelector(".icon-category-section");
        const existingDropdown = categoriesSection.querySelector("[data-dropdown-id]");

        if (!existingDropdown) { // no dropdown currently open
            categoriesSection.insertAdjacentElement("beforeend", dropdownToShow);
            trigger.classList.add("dropdownActive");

        } else if (+(existingDropdown.getAttribute("data-dropdown-id")) === index) { // same dropdown currently open
            existingDropdown.remove();
            document.querySelector(".dropdownActive").classList.remove("dropdownActive");

        } else { // different dropdown currently open
            existingDropdown.remove();
            document.querySelector(".dropdownActive").classList.remove("dropdownActive");

            categoriesSection.insertAdjacentElement("beforeend", dropdownToShow);
            trigger.classList.add("dropdownActive");
        }
    }
}

